import { render, staticRenderFns } from "./centerStatement.vue?vue&type=template&id=5bbd29ea&scoped=true&"
import script from "./centerStatement.vue?vue&type=script&lang=js&"
export * from "./centerStatement.vue?vue&type=script&lang=js&"
import style0 from "./centerStatement.vue?vue&type=style&index=0&id=5bbd29ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbd29ea",
  null
  
)

export default component.exports